export const noteCss = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900');
  #print-notereport {
    color: #000;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    padding: 20mm 2mm;
    margin: 0;
    width: 210mm;
  }
  h1 { font-size: 24px; }
  h2 { font-size: 18px; }
  h3 { font-size: 16px; }
  h1, h2, h3 { margin-top: 12px; margin-bottom: 8px; }
  ul, ol { font-size: 12px; line-height: 1.4; padding-left: 12px; }
  p { padding: 0.25em; margin-top: 0.5em; }
  img { margin: 10px 5px; }
  .no-print { display: none; }
  .print { opacity: 1 !important; height: initial !important; }
`;
